import gql from "graphql-tag";

export const GET_USER = gql`
  query getUserDetails {
    getCustomer {
      name
      surname
      role
      email
      contactEmail
      pec
      isLegacy
      isCondominiumAdminDisabled
      mobilePhoneNumber
      landlinePhoneNumber
      fiscalCode
      agreementProfiling
      agreementMarketing
      businessName
      customerCity
      fax
      legalAddress {
        street
        streetNumber
        postalCode
        city
        province
        region
        country
      }
      headOfficeAddress {
        street
        streetNumber
        postalCode
        city
        province
        region
        country
      }
      accountDetail {
        picture
      }
    }
  }
`;

export const PASSWORD_EXPRIRATION = gql`
  query Customer {
    passwordExpirationCheck {
      isExpired
    }
  }
`;

export const GET_OPERATOR_CASES = gql`
  query getOperatorCasesList {
    getOperator {
      cases {
        elements {
          caseId
          caseNumber
          draft
          type
          status
          issueDate
          draftAsJson
          path
          contract {
            contractId
            accountHolder {
              integraClientCode
              surname
            }
          }
          operator {
            id
            fiscalCode
            email
          }
        }
      }
    }
  }
`;

export const GET_CUSTOMER_CASES = gql`
  query getCustomerCasesList {
    getCustomer {
      cases {
        elements {
          caseId
          caseNumber
          draft
          type
          subType
          status
          issueDate
          path
          contract {
            contractId
            accountHolder {
              name
              surname
              integraClientCode
            }
          }
          operator {
            id
            fiscalCode
            email
          }
          draftAsJson
        }
      }
    }
  }
`;

export const GET_OPERATOR = gql`
  query getOperatorDetails {
    getOperator {
      name
      surname
      role
      email
      pec
      mobilePhoneNumber
      landlinePhoneNumber
      fiscalCode
      agreementProfiling
      agreementMarketing
      businessName
      operatorCity
      accountDetail {
        picture
      }
      legalAddress {
        street
        streetNumber
        postalCode
        city
        province
        region
        country
      }
      headOfficeAddress {
        street
        streetNumber
        postalCode
        city
        province
        region
        country
      }
    }
  }
`;
export const IMPERSONIFICATION_SEARCH_USER = gql`
  query searchUser($type: SearchUserType!, $value: String!) {
    searchUser(req: { type: $type, value: $value }) {
      ... on CustomerSearchResult {
        customer {
          username
          fiscalCode
          email
          safoAccountId
          name
          surname
          role
          accountDetail {
            emailVerified
            status
          }
          authIssuer
          isCondominiumAdminDisabled
          impersonateToken
        }
      }
      ... on OperatorSearchResult {
        operator {
          username
          fiscalCode
          email
          safoAccountId
          name
          surname
          role
          accountDetail {
            emailVerified
            status
          }
        }
      }
    }
  }
`;
export const LIST_CONTRACTS = gql`
  query listContractsFull($recordsPerPage: Int, $page: Int) {
    listContracts(req: { recordsPerPage: $recordsPerPage, page: $page }) {
      pagination {
        totalElements
      }
      elements {
        contractId
        integraClientCode
        integraContractCode
        status {
          code
        }

        puf {
          street
          streetNumber
          city
        }
        accountHolder {
          businessName
        }

        serviceOnlineBill {
          enabled
          email
        }
        serviceBankDomiciliation {
          enabled
        }

        serviceLoanLossProvisions {
          enabled
        }
      }
    }
  }
`;
export const LIST_CONTRACTS_SMALL = gql`
  query listContractsSmall($recordsPerPage: Int, $page: Int) {
    listContracts(req: { recordsPerPage: $recordsPerPage, page: $page }) {
      pagination {
        totalElements
      }
      elements {
        contractId
        integraClientCode
        integraContractCode
        status {
          code
        }
        puf {
          street
          streetNumber
          city
          province
          postalCode
        }
        serviceOnlineBill {
          enabled
          email
        }
        accountHolder {
          businessName
          fiscalCode
          vatNumber
          address {
            street
            streetNumber
            city
          }
        }
      }
    }
  }
`;
export const LIST_CONTRACTS_WITH_FILTER_SMALL = gql`
  query listContractsWithFilterSmall($listContractsReq: ListContractsReq!) {
    listContracts(req: $listContractsReq) {
      elements {
        contractId
        integraClientCode
        integraContractCode
        status {
          code
        }
        puf {
          street
          streetNumber
          city
          province
          postalCode
        }
        serviceOnlineBill {
          enabled
          email
        }
      }
    }
  }
`;
export const CONTRACT_DETAIL = gql`
  query getContractDetailFull(
    $contractDetailReq: ContractDetailReq!
    $InvoicesReq: InvoicesReq
  ) {
    contractDetail(req: $contractDetailReq) {
      contractId
      invoices(req: $InvoicesReq) {
        pagination {
          totalPages
          totalElements
          pageSize
          currentPage
        }
        elements {
          id
          invoiceNumber
          issueDate
          expirationDate
          amount
          paidAmount
          residualAmount
          isPaid
          deferredPayment
          printType
          documentType
        }
      }
      metre {
        serialNumber
        location
        diameter
        indicesNumber
        consumptions {
          elements {
            invoiceNumber
            consumption
            initialMetreReading
            finalMetreReading
            metreReadingStatus
            startDate
            endDate
          }
        }
      }
      serviceOnlineBill {
        enabled
        email
      }
      serviceBankDomiciliation {
        enabled
      }
      telemeter
    }
  }
`;
export const DOWNLOAD_BILLS = gql`
  query invoicesDownload($req: InvoicesDownloadReq!) {
    invoicesDownload(req: $req) {
      path
    }
  }
`;
export const MUNICIPAL_BILL_DOWNLOAD = gql`
  query municipalInvoicesDownload($req: MunicipalInvoicesReq!) {
    municipalInvoicesDownload(req: $req) {
      path
    }
  }
`;
export const CONDOMINIUM_ADMIN_INVOICES_DOWNLOAD = gql`
  query condominiumAdminInvoicesDownload($req: CondominiumAdminInvoicesReq!) {
    condominiumAdminInvoicesDownload(req: $req) {
      path
    }
  }
`;
export const GET_CONSUMPTION = gql`
  query getContractConsumption($contractDetailReq: ContractDetailReq!) {
    contractDetail(req: $contractDetailReq) {
      contractId
      metre {
        serialNumber
        diameter
        location
        indicesNumber
        consumptions {
          pagination {
            totalPages
            totalElements
            pageSize
            currentPage
          }
          elements {
            invoiceNumber
            startDate
            endDate
            initialMetreReading
            finalMetreReading
            consumption
            metreReadingStatus
          }
        }
      }
    }
  }
`;
export const GET_CONTRACT_METRESERIALNUMBER = gql`
  query searchContractByMetre($metreSerialNumber: String!) {
    searchContract(req: { metreSerialNumber: $metreSerialNumber }) {
      contractId
      metreSerialNumber
      integraClientCode
      integraContractCode
      status {
        code
        description
      }
      serviceLoanLossProvisions {
        enabled
      }
      serviceOnlineBill {
        enabled
        email
      }
      arera {
        classification
        subtype
      }
      contacts {
        businessName
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      accountHolder {
        businessName
        fiscalCode
        vatNumber
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      puf {
        code
        street
        streetNumber
        city
        province
        postalCode
      }
      token
    }
  }
`;
export const GET_CONTRACT_FISCAL_CODE = gql`
  query searchContractList($fiscalNumber: String!) {
    searchContractList(req: { fiscalNumber: $fiscalNumber }) {
      contracts {
        contractId
        metreSerialNumber
        integraClientCode
        integraContractCode
        status {
          code
          description
          __typename
        }
        serviceLoanLossProvisions {
          enabled
          __typename
        }
        serviceOnlineBill {
          enabled
          email
          __typename
        }
        arera {
          classification
          subtype
          __typename
        }
        contacts {
          businessName
          address {
            code
            street
            streetNumber
            city
            province
            postalCode
            __typename
          }
          __typename
        }
        accountHolder {
          businessName
          fiscalCode
          vatNumber
          address {
            code
            street
            streetNumber
            city
            province
            postalCode
            __typename
          }
          __typename
        }
        puf {
          code
          street
          streetNumber
          city
          province
          postalCode
          __typename
        }
        token
        __typename
      }
    }
  }
`;
export const GET_CONTRACT = gql`
  query searchContractFull(
    $integraContractCode: String!
    $invoiceNumber: String!
  ) {
    searchContract(
      req: {
        integraContractCode: $integraContractCode
        invoiceNumber: $invoiceNumber
      }
    ) {
      contractId
      metreSerialNumber
      integraClientCode
      integraContractCode
      status {
        code
        description
      }
      serviceLoanLossProvisions {
        enabled
      }
      serviceOnlineBill {
        enabled
        email
      }
      arera {
        classification
        subtype
      }
      contacts {
        businessName
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      accountHolder {
        businessName
        fiscalCode
        vatNumber
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      puf {
        code
        street
        streetNumber
        city
        province
        postalCode
      }
      token
    }
  }
`;
export const CHECK_CONTRACT = gql`
  query checkContract(
    $integraClientCode: String
    $integraContractCode: String
    $invoiceNumber: String!
  ) {
    checkContract(
      req: {
        integraClientCode: $integraClientCode
        integraContractCode: $integraContractCode
        invoiceNumber: $invoiceNumber
      }
    ) {
      contractId
      clientId
    }
  }
`;
export const GET_CONTRACT_GAN = gql`
  query searchContractGan(
    $integraContractCode: String!
    $invoiceNumber: String!
  ) {
    searchContract(
      req: {
        integraContractCode: $integraContractCode
        invoiceNumber: $invoiceNumber
        process: SUBENTRO
      }
    ) {
      contractId
      metreSerialNumber
      integraClientCode
      integraContractCode
      status {
        code
        description
      }
      serviceLoanLossProvisions {
        enabled
      }
      serviceOnlineBill {
        enabled
        email
      }
      arera {
        classification
        subtype
      }
      contacts {
        businessName
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      accountHolder {
        businessName
        fiscalCode
        vatNumber
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      puf {
        code
        street
        streetNumber
        city
        province
        postalCode
      }
      token
    }
  }
`;
export const GET_CONTRACT_METRESERIALNUMBER_GAN = gql`
  query searchContractByMetreGan($metreSerialNumber: String!) {
    searchContract(
      req: { metreSerialNumber: $metreSerialNumber, process: SUBENTRO }
    ) {
      contractId
      metreSerialNumber
      integraClientCode
      integraContractCode
      status {
        code
        description
      }
      serviceLoanLossProvisions {
        enabled
      }
      serviceOnlineBill {
        enabled
        email
      }
      arera {
        classification
        subtype
      }
      contacts {
        businessName
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      accountHolder {
        businessName
        fiscalCode
        vatNumber
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      puf {
        code
        street
        streetNumber
        city
        province
        postalCode
      }
      token
    }
  }
`;
export const GET_CONTRACT_ADD = gql`
  query searchContractAdd(
    $integraContractCode: String!
    $invoiceNumber: String!
    $operation: OperationSearchContract
  ) {
    searchContract(
      req: {
        integraContractCode: $integraContractCode
        invoiceNumber: $invoiceNumber
        operation: $operation
      }
    ) {
      contractId
      metreSerialNumber
      integraClientCode
      integraContractCode
      status {
        code
        description
      }
      serviceLoanLossProvisions {
        enabled
      }
      serviceOnlineBill {
        enabled
        email
      }
      arera {
        classification
        subtype
      }
      contacts {
        businessName
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      accountHolder {
        businessName
        fiscalCode
        vatNumber
        address {
          code
          street
          streetNumber
          city
          province
          postalCode
        }
      }
      puf {
        code
        street
        streetNumber
        city
        province
        postalCode
      }
      token
    }
  }
`;
export const GET_BILL_DETAIL = gql`
  query getPaymentDetail($trackidpayment: String!, $contractId: String!) {
    getPaymentDetail(
      req: { trackidpayment: $trackidpayment, contractId: $contractId }
    ) {
      idIntegra
      contractIdIntegra
      idPaymentSetefi
      amountPayment
      businessName
      trackIdPayment
      bills {
        id
        date
        amount
      }
    }
  }
`;
export const GET_LIST_READING = gql`
  query listReading($daData: String, $aData: String, $contractId: String) {
    listReading(
      req: { daData: $daData, aData: $aData, contractId: $contractId }
    ) {
      readings {
        accountholderId
        contractId
        accountholder
        data
        reading
      }
    }
  }
`;

export const GET_DASHBOARD_CONSUME = gql`
  query getDashboardConsumptions($contractId: String!) {
    getDashboardConsumptions(req: { contractId: $contractId }) {
      consumptions {
        year
        month
        consumption
      }
    }
  }
`;

export const GET_STATES = gql`
  query getStates {
    getStates {
      id
      value
      key
      code
    }
  }
`;
export const GET_IBAN_VALIDATION = gql`
  query ibanCheck($iban: String!) {
    ibanCheck(req: { iban: $iban }) {
      outcome
      details {
        bank
        branch
      }
    }
  }
`;
export const GET_INVOICE_INFO = gql`
  query InvoiceInfo($codIdBolletta: String) {
    invoiceInfo(req: { codIdBolletta: $codIdBolletta }) {
      invoiceNumber
      amount
      invoiceType
      consumption
    }
  }
`;
export const INVOICE_PARTITION_CALCULATION = gql`
  query InvoicePartitionCalculation(
    $amountInvoice: Float!
    $unit_0: Int!
    $unit_1: Int!
    $unit_2: Int!
    $unit_3: Int!
    $unit_4: Int!
    $unit_5: Int!
    $unit_6: Int!
    $unit_7: Int!
    $unit_8: Int!
    $unit_9: Int!
    $unit_10: Int!
    $non_residential: Int!
  ) {
    invoicePartitionCalculation(
      req: {
        amountInvoice: $amountInvoice
        condominiumPartition: {
          unit_0: { quantity: $unit_0 }
          unit_1: { quantity: $unit_1 }
          unit_2: { quantity: $unit_2 }
          unit_3: { quantity: $unit_3 }
          unit_4: { quantity: $unit_4 }
          unit_5: { quantity: $unit_5 }
          unit_6: { quantity: $unit_6 }
          unit_7: { quantity: $unit_7 }
          unit_8: { quantity: $unit_8 }
          unit_9: { quantity: $unit_9 }
          unit_10: { quantity: $unit_10 }
          non_residential: { quantity: $non_residential }
        }
      }
    ) {
      amountInvoice
      condominiumPartition {
        unit_0 {
          unitAmount
        }
        unit_1 {
          unitAmount
        }
        unit_2 {
          unitAmount
        }
        unit_3 {
          unitAmount
        }
        unit_4 {
          unitAmount
        }
        unit_5 {
          unitAmount
        }
        unit_6 {
          unitAmount
        }
        unit_7 {
          unitAmount
        }
        unit_8 {
          unitAmount
        }
        unit_9 {
          unitAmount
        }
        unit_10 {
          unitAmount
        }
        non_residential {
          unitAmount
        }
      }
    }
  }
`;
export const GET_DASHBOARD_CONSUMPTIONS_AS_XLS = gql`
  query getDashboardConsumptionsAsXls($contractId: String!) {
    getDashboardConsumptionsAsXls(req: { contractId: $contractId }) {
      path
    }
  }
`;
export const GET_REPORT_CONDOMINIUM_ADMIN_REGISTRY_AS_XLS = gql`
  query getReportCondominiumAdminRegistryAsXls {
    getReportCondominiumAdminRegistryAsXls {
      path
    }
  }
`;
export const CONDOMINIUM_ADMIN_INVOICES_LIST = gql`
  query condominiumAdminInvoicesList($req: CondominiumAdminInvoicesReq!) {
    condominiumAdminInvoicesList(req: $req) {
      pagination {
        currentPage
        pageSize
        totalElements
        totalPages
      }
      elements {
        id
        contractId
        invoiceNumber
        issueDate
        expirationDate
        amount
        paidAmount
        residualAmount
        isPaid
        deferredPayment
        printType
        documentType
        clientCodeIntegra
        contractCodeIntegra
        businessName
        puf {
          street
          streetNumber
          city
          province
          postalCode
        }
      }
    }
  }
`;

export const MUNICIPAL_INVOICES_LIST = gql`
  query municipalInvoicesList($req: MunicipalInvoicesListReq!) {
    municipalInvoicesList(req: $req) {
      pagination {
        currentPage
        pageSize
        totalElements
        totalPages
      }
      elements {
        id
        contractId
        invoiceNumber
        issueDate
        expirationDate
        amount
        paidAmount
        residualAmount
        isPaid
        deferredPayment
        printType
        documentType
        clientCodeIntegra
        contractCodeIntegra
        businessName
        puf {
          street
          streetNumber
          city
          province
          postalCode
        }
      }
    }
  }
`;

export const GET_BANK_DOMICILIATION = gql`
  query retrieveBankDomiciliation($req: RetrieveBankDomiciliationReq!) {
    retrieveBankDomiciliation(req: $req) {
      bankProfile {
        businessName
        fiscalCode
        phoneNumber
        address
        email
      }
      bankData {
        IBAN
        bankName
        branchName
      }
      accountHolder {
        contactsInfo {
          email
          phoneNumber
        }
      }
    }
  }
`;
